import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import agent from "../../api/agent";
import { ShipmentResponse } from "../../models/responseModels/shipmentResponse";
import { ShipmentDownloadResponse, ShipmentUIResponse } from "../../models/ApiResponse";

type InitialState = {
    isLoading: boolean;
    shipmentList: ShipmentResponse[];
    errorMessage: string | null;
  };

const initialState : InitialState = {
    isLoading : false,
    shipmentList : [],
    errorMessage : null
};

export const getShipmentList =
     createAsyncThunk<ShipmentUIResponse>(
     "shipment/getshipmentlist",
     async () => {
        const response = 
            await agent.ShipmentAgent.getShipmentList();
        return response;
     }
)

export const downloadshipmentDataToCsv = createAsyncThunk<
  ShipmentDownloadResponse,
  ShipmentResponse[]
>(
  "shipment/downloadCsv",
  async (shipmentData: ShipmentResponse[]) => {
    const response =
      await agent.ShipmentAgent.shipmentCsvDownload(
        shipmentData
      );
    return response;
  }
);

export const downloadshipmentDataToXlsx = createAsyncThunk<
  Blob,
  ShipmentResponse[]
>(
  "shipment/downloadXlsx",
  async (shipmentData: ShipmentResponse[]) => {
    const response =
      await agent.ShipmentAgent.shipmentXlsxDownload(
        shipmentData
      );
    return response;
  }
);

const shipmentSlice = createSlice({
   name : "shipment" ,
   initialState,
   reducers : {},
   extraReducers : (builder) => {
    builder
        .addCase(getShipmentList.pending, (state) => {
            state.isLoading = true;
        })
        .addCase(getShipmentList.fulfilled, (state, action) => {
            state.isLoading = false;
            if(action.payload.isSuccess){
                state.shipmentList = action.payload.data;
            }
            else{
                state.shipmentList = [];
            }
        })
        .addCase(getShipmentList.rejected, (state, action) => {
            state.isLoading = false;
            state.shipmentList = [];
            state.errorMessage = action.error.message!;
        })
        .addCase(downloadshipmentDataToCsv.pending, (state) => {
            state.isLoading = false;
          })
        .addCase(downloadshipmentDataToCsv.fulfilled, (state, action) => {
            state.isLoading = false;
        })
        .addCase(downloadshipmentDataToCsv.rejected, (state, action) => {
            state.isLoading = false;
            state.errorMessage = action.error.message!;
        })
        .addCase(downloadshipmentDataToXlsx.pending, (state) => {
            state.isLoading = false;
        })
        .addCase(downloadshipmentDataToXlsx.fulfilled, (state, action) => {
            state.isLoading = false;
        })
        .addCase(downloadshipmentDataToXlsx.rejected, (state, action) => {
            state.isLoading = false;
            state.errorMessage = action.error.message!;
        });
   }
});

export default shipmentSlice.reducer;
